import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { ScreenContainer } from "@src/components/ScreenContainer";
import { Button } from "@src/components/Button";
import { Icon } from "@src/components/Icon";

interface ErrorScreenProps {
  error: string;
  onRetry: () => void;
}

export function ErrorScreen({ error, onRetry }: ErrorScreenProps) {
  const { theme } = useUnistyles();

  return (
    <ScreenContainer edges={["top", "bottom"]}>
      <View flex={1} bg="background" justifyContent="center" alignItems="center" gap="4xl" px="6xl">
        <View
          w={theme.spacing["14xl"]}
          h={theme.spacing["14xl"]}
          borderRadius={theme.spacing["10xl"]}
          bg="danger"
          justifyContent="center"
          alignItems="center"
        >
          <Icon name="error" size={40} color={theme.colors.danger[500]} />
        </View>
        <View gap="md" alignItems="center">
          <Text textStyle="xl" fontWeight="600" textAlign="center">
            Authentication Failed
          </Text>
          <Text textStyle="md/regular" color="textMuted" textAlign="center">
            {error}
          </Text>
        </View>
        <Button
          label="Try Again"
          variant="primary"
          onPress={onRetry}
          iconLeft={<Icon name="refresh" size={20} color={theme.colors.white.default} />}
        />
      </View>
    </ScreenContainer>
  );
}
